export default __webpack_public_path__ + "media/images/backgrounds/tw-db4dcaafec0159aaaa8deeb68bc7c94d.jpg";